import $ from 'jquery';
import EFOcats_settingdata from '../../../core/v2/setting/efocats_settingdata.js';

export default class EFOcats_curves_settingdata extends EFOcats_settingdata {
  /**
   * 入力欄をページごとに振り分ける
   * @param {*} form
   * @returns ページリスト
   */
  get_pages(form) {
    const pages = super.get_pages(form);
    pages.shift();
    pages.pop();

    pages.splice(2, 0, pages[4]);
    pages.splice(5, 1);

    pages.splice(4, 0, pages[5]);
    pages.splice(6, 1);

    return pages;
  }

  /**
   * 入力欄の情報を取得する
   * @param {*} input
   * @param {*} temp
   */
  get_input_info(page, input, temp) {
    const nameList = [];

    for (let k = 0, l = input.length; k < l; k++) {
      if (input[k].type === 'radio' || input[k].type === 'checkbox') {
        // 既に処理したnameのものはスキップ
        if (nameList.indexOf(input[k].name) === -1) {
          nameList.push(input[k].name);

          const tempval = [];

          for (let index = 0; index < input.length; index++) {
            if (input[index].name === input[k].name) {
              const val = {};
              val[input[index].value] = input[index].parentNode.textContent;
              tempval.push(val);
            }
          }

          const tempanswer = {
            type: input[k].type,
            name: input[k].name,
            'data-required': String(this.get_required(page)),
            value: tempval,
          };

          // 属性設定
          this.get_attr(page, input, k, tempanswer);

          temp.answer.push(tempanswer);
        }
      } else {
        const tempanswer = {
          type: this.get_type(input, k),
          name: input[k].name,
          'data-required': String(this.get_required(page)),
        };

        if (tempanswer.type === 'select') {
          tempanswer.value = [];
          const option = input[k].querySelectorAll('option');
          for (let n = 0; option.length > n; n++) {
            const tempval = {};
            tempval[option[n].value] = option[n].text;
            tempanswer.value[n] = tempval;
          }
        }

        // 属性設定
        this.get_attr(page, input, k, tempanswer);

        temp.answer.push(tempanswer);
      }
    }
  }

  /**
   * ページ内の入力欄を一通り取得する
   * @param {*} page
   * @returns 入力欄リスト
   */
  get_inputs(page) {
    const inputs = [];

    const list = $(page).find('input,select,textarea');

    for (let index = 0; index < list.length; index++) {
      if (list.eq(index).attr('type') !== 'hidden') {
        inputs.push(list[index]);
      }
    }

    return inputs;
  }

  get_attr(page, inputs, index, tempanswer) {
    super.get_attr(page, inputs, index, tempanswer);

    const name = $(inputs[index]).attr('name');

    if (name === 'entry1_time' && inputs.length === 2) {
      tempanswer.line = 0;
    } else if (name === 'entry2_time' && inputs.length === 2) {
      tempanswer.line = 1;
    }
  }
}
